import LeaveGuard from "@/mixins/LeaveGuard";
export default {
  name: "BaseDetailPage",
  components: {
    BaseDetailSimple: () => import("@/components/BaseDetailSimple")
  },
  mixins: [LeaveGuard]
};
